import React from 'react';
import { ReactComponent as ShieldIcon } from '../../assets/icons/shield.svg';
import { ReactComponent as ShieldCheckIcon } from '../../assets/icons/shield-check.svg';

const DEFAULT_SIZE = 24;

function dimensionValue(value) {
  if (value === undefined || value === null) return undefined;
  return typeof value === 'number' ? `${value}px` : value;
}

function colorFor(level){
  const normalizedLevel = String(level || '').trim().toLowerCase();
  if (normalizedLevel === 'high') return 'var(--warning)';
  if (normalizedLevel === 'medium') return 'var(--bot)';
  return 'var(--primary)';
}

export default function Shield({ fraudLevel, className, style, size, ...rest }) {
  const normalizedLevel = String(fraudLevel || '').trim().toLowerCase();
  const color = colorFor(fraudLevel);
  const hasExplicitWidth = style?.width !== undefined;
  const hasExplicitHeight = style?.height !== undefined;
  const fallbackSize = dimensionValue(size) ?? `${DEFAULT_SIZE}px`;
  const common = {
    className,
    style: { fill: color, ...(style || {}) },
    ...rest,
    ...(hasExplicitWidth ? {} : { width: fallbackSize }),
    ...(hasExplicitHeight ? {} : { height: fallbackSize }),
  };

  if (normalizedLevel === 'high' || normalizedLevel === 'medium') {
    return <ShieldIcon {...common} />;
  }
  return <ShieldCheckIcon {...common} />;
}
